export default "__VITE_ASSET__Fne7MLC5__"